import { Component, Input, OnInit } from '@angular/core';
import { AlertService, ConfirmationStoreService, IAlertType } from "../../../../_shared/services";
import { ClrDatagridModule, ClrDatagridSortOrder } from "@clr/angular";
import { Confirmations } from "../../../../_shared/interfaces";
import { DatePipe, NgIf } from "@angular/common";
import { RouterLink } from "@angular/router";

@Component({
  selector: 'app-job-details-confirmation',
  standalone: true,
  imports: [
    NgIf,
    ClrDatagridModule,
    RouterLink,
    DatePipe
  ],
  templateUrl: './job-details-confirmation.component.html',
  styleUrl: './job-details-confirmation.component.sass'
})
export class JobDetailsConfirmationComponent implements OnInit {
  confirmation : Confirmations[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() projectID!: string;
  @Input() jobID!: number;

  constructor(
    private confss: ConfirmationStoreService,
    private alertDispatcher: AlertService,
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.loadList(this.projectID, this.jobID);
  }

  loadList(projectID: string, jobID: number) {
    this.confss.getConfirmation(projectID, jobID, 0).subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.alertConfig.message = 'Keine Confirmationdaten gefunden!';
          this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
          return;
        }
        this.confirmation = data.object;
      },
      complete: () => {
        this.loading = false;
        this.descSort = ClrDatagridSortOrder.DESC;
      },
      error: () => {
        return
      }
    });
  }
}
